<template>
  <div class="row-content">
    <EquipmentRequestIcon
      v-if="equipmentTypesEnabled"
      :status="equipmentRequestStatus"
      class="mr-2 inline-flex"
      @click="handleEqRequestClick"
    />
    <div class="name-cont">
      <div class="name-container">
        <strong v-if="!editing" class="name-text">{{ itemName }}</strong>
        <input
          v-else-if="editing && open"
          class="unit-name-input"
          type="text"
          :value="item.unit_name"
          @change="handleEdit"
        />
        <a v-else @click="emitReplaceItem">
          <strong>{{ itemName }}</strong>
        </a>
      </div>
    </div>
    <ChevronIcon
      v-if="editing"
      class="arrow-button"
      :direction="open ? 'up' : 'down'"
      @click="$emit('toggle-open-details')"
    />
  </div>
</template>

<script lang="ts">
import EquipmentRequestIcon from "serviceshift-ui/components/Equipment/EquipmentRequestIcon.vue";
import ChevronIcon from "serviceshift-ui/components/General/ChevronIcon.vue";
import EventBus from "serviceshift-ui/shared/src/lib/event_bus";

import { InvoiceLineItem } from "@/typings/invoice";
import { QuoteLineItem } from "@/typings/quote";

export default {
  components: {
    ChevronIcon,
    EquipmentRequestIcon
  },
  emits: [
    "toggle-open-details",
    "edit-unit-name",
    "replace-line-item",
    "equipment-request-click"
  ],
  props: {
    item: {
      type: Object as () => QuoteLineItem | InvoiceLineItem,
      default: () => ({})
    },
    open: {
      type: Boolean,
      default: false
    },
    editing: {
      type: Boolean,
      default: false
    },
    eventId: {
      type: Number,
      default: null
    },
    equipmentTypesEnabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    itemName() {
      const coveredSystems =
        this.item.item_type === "membership_program" &&
        this.item.covered_systems
          ? ` - Covered Systems (${this.item.covered_systems})`
          : "";
      return `${this.item.unit_name}${coveredSystems}`;
    },
    equipmentRequestStatus() {
      return this.item.equipment_request_status;
    }
  },
  methods: {
    handleEdit(e: Event) {
      EventBus.$emit("edit-unit-name", e, this.item, this.eventId);
    },
    emitReplaceItem() {
      EventBus.$emit("replace-line-item", this.item, this.eventId);
    },
    handleEqRequestClick() {
      EventBus.$emit("equipment-request-click", this.item, this.eventId);
    }
  }
};
</script>

<style lang="scss" scoped>
.unit-name-input {
  width: 100%;
  border: 1px solid var(--primary-accent-color);
  border-radius: 5px;
  padding: 2px 10px;
  margin: 5px 5px;
  min-height: 30px;
  font-family: inherit;
  font-size: 1em;
}

.name-container {
  width: 98%;
}

.arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.arrow-button {
  margin-left: 10px;
  cursor: pointer;
}

.name-cont {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
}

.row-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cover-systems-container {
  margin-left: 10px;
  white-space: nowrap;
}
.cover-systems-text {
  margin-right: 15px;
}

.name-text {
  font-weight: 500;
}
.link {
  color: #027db4 !important;
  cursor: pointer;
  &:hover {
    color: darken(#027db4, 10%) !important;
    text-decoration: underline;
  }
}
</style>
